
import { Component, Pipe, PipeTransform } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, App } from 'ionic-angular';
import { AppState } from '../../../app/app.global';


import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { THIRD_APP_JUMP,NEWS_SEARCH_BY_KEYWORD, SEARCH_MYALLAPPS_BY_KEYWORD, SEARCH_MYREMINDER, SEARCH_MYTODO } from '../../../providers/config/serviceurl';

import { NewsDetail } from '../../home/news/detail/detail';
import { SearchmorePage } from '../searchmore/searchmore';
import { MessagedetailPage } from '../messagedetail/messagedetail';
import { Utils } from '../../../providers/service/utils';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
@Component({
  selector: 'page-single-search',
  templateUrl: 'singlesearch.html',
})
export class SingleSearchPage {
  user: any = {};
  resourceUrl:any;//资源url；

  //控制是否显示新闻
  public isShowNews = false;
  //控制是否显示应用
  public isShowApplication = false;
  //控制是否显示应用
  public isShowMessage = false;
  //关键词
  public searchKey: any;

  public searchType: any;

  public searchTypeName: any;

  public newsAmount: any;
  //新闻列表
  public newsList: any = [];
  //服务列表
  public serviceList: any = [];
  //提醒消息列表
  public reminderMsgList: any = [];
  //提醒消息列表
  public myToDoMsgList: any = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private httpService: HttpService, public global: AppState,private inAppBrowser:InAppBrowser,
    private alertCtrl: AlertController, public appCtrl: App) {
    this.user = StorageService.getObj('currentUser');
    this.resourceUrl = StorageService.getObj('resourceUrl');
    this.searchType = navParams.data.searchType;
    if (this.searchType === 'news') {
      this.searchTypeName='新闻';
    }else if (this.searchType === 'application') {
      this.searchTypeName='应用';
    }else if (this.searchType === 'message') {
      this.searchTypeName='消息';
    }
  }

  ionViewDidLoad() {
   // console.log('ionViewDidLoad CommonsearchPage');
  }

  //取消
  cancel() {
    this.navCtrl.pop();
  }

  //搜索
  search(e: any) {
    if (e.target.value == undefined || e.target.value == null || e.target.value == "") {
      this.isShowNews = false;
      this.isShowApplication = false;
      this.isShowMessage = false;
      return;
    } 

    //搜索框内容
    this.searchKey = e.target.value;
    //搜索新闻
    let params = { 'username': this.user.xgh, 'pageNo': 0, 'pageSize': 3, 'loadAll': false, 'keyword': this.searchKey };

    if (this.searchType === 'news') {
      this.isShowNews = true;
      this.isShowApplication = false;
      this.isShowMessage = false;
      this.httpService.get2(NEWS_SEARCH_BY_KEYWORD, params).then(anyObj => this.handleNewsList(anyObj));
    }else if (this.searchType === 'application') {
      this.isShowNews = false;
      this.isShowApplication = true;
      this.isShowMessage = false;
      //搜索服务
     this.httpService.get2(SEARCH_MYALLAPPS_BY_KEYWORD, params).then(anyObj => this.handleServiceList(anyObj));
    }else if (this.searchType === 'message') {
      this.isShowNews = false;
      this.isShowApplication = false;
      this.isShowMessage = true;
      let remindParams = { 'username': this.user.xgh, 'pageNo':0,'pageSize':3,'code': '01', 'keyword':this.searchKey};
      //提醒搜索
      this.httpService.get2(SEARCH_MYREMINDER, remindParams).then(anyObj => this.handleReminderMsgList(anyObj));
      //待办搜索
      let toDoParams = { 'username': this.user.xgh, 'pageNo':0,'pageSize':3,'code': '02', 'keyword':this.searchKey};
      this.httpService.get2(SEARCH_MYTODO, toDoParams).then(anyObj => this.handleMyToDoMsgList(anyObj));
    }
  }
  handleNewsList(obj: any) {
    if (obj) {
      // console.log(JSON.parse(obj));
      this.newsList = obj;
    }
  }
  handleServiceList(obj: any) {
    if (obj) {
      // console.log(JSON.parse(obj));
      this.serviceList = obj;
    }
  }
  handleReminderMsgList(obj: any) {
    if (obj) {
      let returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result;
        if ((result = regex.exec(str)) != null) {
          returnData[index].content = result[1];
        }
      }
      this.reminderMsgList.items = returnData;
      this.reminderMsgList.totalItems = obj.totalItems;
    }
  }

  handleMyToDoMsgList(obj: any) {
    if (obj) {
      let returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result;
        if ((result = regex.exec(str)) != null) {
          returnData[index].content = result[1];
        }
      }
      this.myToDoMsgList.items = returnData;
      this.myToDoMsgList.totalItems = obj.totalItems;
    }
  }

  //点击具体搜索内容
  gotoServe(event: any, item: any, flag: any) {
    item.flag = flag;
    if ('news' == flag) {
      this.appCtrl.getRootNav().push(NewsDetail, item);
    } else if ('service' == flag) {
    	let colorTheme = this.global.colorTheme;
	    if(item != null && item != undefined){
		  let o = item.SERVICE_APP_SUBSERVICE;
		  if(o != null && o != undefined && o !=''){
		     let title = o[0].SUBSERVICE_NAME;
		     let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
		     let flag = "thirdApp";
		     if(url.indexOf(flag) != -1){
			   this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_self','location=yes');
		  }else{
			   this.httpService.openOuterLink(title, url,colorTheme);
		  }
		  }
	    }
    } else if ('reminderMsg' == flag) {
      this.appCtrl.getRootNav().push(MessagedetailPage, item);
    } else if ('myToDoMsg' == flag) {
      this.appCtrl.getRootNav().push(MessagedetailPage, item);
    }
  }

  urlencode (str) {  
    str = (str + '').toString();   
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
 } 

  //点击查看更多
  searchAllServiceByKeyword(flag: any) {
    this.appCtrl.getRootNav().push(SearchmorePage, { 'flag': flag, 'keyword': this.searchKey });
  }
}




// WEBPACK FOOTER //
// ./src/pages/commonsearch/singlesearch/singlesearch.ts